import FormList from '../components/form-builder/FormList';

export default function FormListPage() {
  return <FormList />;
}
